export default "/images/ethereum_environment__icon.png";